import { LanguageCode } from '@/types/language';

const defaultLanguageCode = LanguageCode.EN;

const translateURL = (locale: string, url: string) => {
  if (locale === defaultLanguageCode) {
    return url;
  }
  return `/${locale}${url?.startsWith('/') ? url : `/${url}`}`;
};

export default translateURL;
